const itemData = document.querySelector("#fast-order").dataset;

const initialState = {
    itemData,
    step: 1,
    delivery: "courier",
    discount: {
        coupon: '',
        price: 0,
        value: 0,
    },
    deliveryPrice: {
        courier: 350,
        post: 250,
    },
    user: {
        surname: {
            value: '',
            gender: null,
        },
        name: {
            value: '',
        },
        phone: {
            value: '',
        }
    },
    geo: {
        city: {
            value: '',
        },
        street: {
            value: '',
        },
        house: {
            value: '',
        },
        apartment: {
            value: '',
        }
    },
    orderId: '',
    smsAttempt: 1,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SURNAME':
            return {
                ...state,
                user: {
                    ...state.user,
                    surname: action.payload
                }
            };

        case 'SET_NAME':
            return {
                ...state,
                user: {
                    ...state.user,
                    name: action.payload
                }
            };

        case 'SET_PHONE':
            let value = "";
            if(action.payload.indexOf("_") == -1) {
                value = action.payload;
            }

            return {
                ...state,
                user: {
                    ...state.user,
                    phone: {
                        value: value
                    }
                }
            };

        case 'SET_CITY':
            let res = action.payload;

            if(res.data != undefined) {
                if (res.data.region_with_type != res.value && res.value.indexOf(res.data.region_with_type) < 0) {
                    res.value = `${res.data.region_with_type}, ${res.value}`;
                }
            }

            let newData = {
                ...state,
                geo: {
                    ...state.geo,
                    city: res,
                    street: {
                        value: '',
                    },
                    house: {
                        value: '',
                    },
                    apartment: {
                        value: '',
                    }
                }
            };

            if(action.prices) {
                newData.deliveryPrice = action.prices;
            }

            return newData;
        case 'SET_STREET':
            return {
                ...state,
                geo: {
                    ...state.geo,
                    street: action.payload,
                    house: {
                        value: '',
                    },
                    apartment: {
                        value: '',
                    }
                }
            };

        case 'SET_HOUSE':
            return {
                ...state,
                geo: {
                    ...state.geo,
                    house: action.payload,
                    apartment: {
                        value: '',
                    }
                }
            };

        case 'SET_APARTMENT':
            return {
                ...state,
                geo: {
                    ...state.geo,
                    apartment: {
                        value: action.payload
                    }
                }
            };

        case 'SET_DELIVERY':
            return {
                ...state,
                delivery: action.payload,
            };

        case 'SET_STEP':
            return {
                ...state,
                step: action.payload,
            };

        case 'SEND_ANOTHER_CODE':
            return {
                ...state,
                smsAttempt: state.smsAttempt+1,
            };

        case 'SET_ORDER_ID':
            return {
                ...state,
                orderId: action.payload,
            };

        case 'SET_COUPON_AND_PRICES':
            return {
                ...state,
                discount: {
                    coupon: action.coupon,
                    price: action.price,
                    value: action.value,
                }
            };

        default:
            return state;
    }
};

export default reducer;